import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { CollegeRecrutingCenterService } from '../../services/college-recruiting-center.service';
import { Store, AppFields, AppTypes, StorageUtil } from '../../store';

@Component({
  selector: 'app-high-five-success',
  templateUrl: './high-five-success.component.html',
  styleUrls: ['./high-five-success.component.css'],
  providers: []
})
export class HighFiveSuccessComponent implements OnInit {

  public requestID: number = 0;
  public status: number = 0;
  public homeOrAway: number = 0;
  public successTab: string;
  public success: boolean = false;
  public successText: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private loader: Ng4LoadingSpinnerService,
    private _service: CollegeRecrutingCenterService,
    private store: Store<any>,
  ) {
    this.successTab = this.activatedRoute.snapshot.params.successTab;
  }

  ngOnInit() {
    this.getClubSubscriptionPlans();
    if (this.successTab == 'CollegeRecruting') {
      this.successText = "You have successfully sign up for the College Recruiting program. All of your players and teams will be upgraded over the next 2 hours.";
    } else if (this.successTab == 'Evaluations') {
      this.successText = "You have successfully sign up for the Evaluations program.";
    } else if (this.successTab == 'Video') {
      this.successText = "You have successfully sign up for the Video program.";
    } else if (this.successTab == 'HealthAndFitness') {
      this.successText = "You have successfully sign up for the Health & Fitness program.";
    } else if (this.successTab == 'TeamCompleteProduct') {
      this.successText = "You have successfully sign up for the Team Complete Product.";
    } else if (this.successTab == 'TeamSidelineCheckin') {
      this.successText = "You have successfully sign up for the Team Sideline College Check In.";
    } else if (this.successTab == 'EmailCampaign') {
      this.successText = "You have successfully sign up for the Email Campaign Product.";
    } else if (this.successTab == 'ClubMobileApp') {
      this.successText = "You have successfully sign up for the Club Mobile App Product.";
    }
  }

  getClubSubscriptionPlans() {
    this._service.getClubTeamSubscriptionPlansWithPlanName(StorageUtil.clubID, StorageUtil.teamId || 0).subscribe((rs: any) => {
      this.store.dispatch({
        type: AppTypes.UpdateState,
        payload: {
          [AppFields.SubscriptionPlans]: rs
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/high-five-success/high-five-success.component.ts